// extracted by mini-css-extract-plugin
module.exports = {"link":"EtherscanLink-module--link--3VPC6"};